import { useAuth } from '../../contexts/Auth'
import { supabase } from "../../utils/supabaseClient"
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import Container from "react-bootstrap/Container"
import Spinner from 'react-bootstrap/Spinner'
import userStyles from '../../styles/Userpage.module.css'


export default function StripeReturn() {
    const router = useRouter()
    const { user } = useAuth()

    useEffect(()=>{
        const checkStripeCredentials = async () => {
            const { data, error } = await supabase
                .from("main_profile")
                .select("id, user, stripe_account_id")
                .eq("user", user.id)
            
            const stripe_account_id = data[0].stripe_account_id
            const profile_id = data[0].id


            const json = await fetch("/api/stripe/verify", {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body:JSON.stringify({
                    account_id: stripe_account_id,
                }),
            })  //put in useEffect
            const result = await json.json()
            if (result.verify) {
                //save account details to be true
                const { data, error } = await supabase
                .from("main_profile")
                .update({stripe_confirmed: true})
                .match({id: profile_id})

                router.push("/userpage?stripe=true")
            } else {
                router.push("/userpage?stripe=false")
            }
            return
        }
        checkStripeCredentials()

    }, [user])
    
    
  return (
    <>
      <Container className="py-5" style={{minHeight: '50rem'}}>
          <div className={userStyles.center}>
                  <Spinner className={userStyles.center_spinner} animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                  </Spinner>
          </div>
      </Container>
    </>
  )
}